import { FormattedHTMLMessage } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { type FormFieldComponentProps } from "@/lib/types/types";

interface PassedProps {
  explanation?: string | JSX.Element; // eslint-disable-line
  onKeyDown?: Function;
}

export const CityComponent = ({
  value,
  isErrored,
  onChange,
  isRequired = false,
  onKeyDown = undefined,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps & PassedProps) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("city")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="city"
      value={value}
      onChange={onChange}
      placeholder={placeholder || msg({ id: "cityPlaceholder" })}
      label={<FormattedHTMLMessage id="city" defaultMessage="City" />}
      errorMessage={
        isErrored && <FormattedHTMLMessage id="errorId.invalidCity" defaultMessage="Invalid city" />
      }
      showPlaceholderAndHideLabel={!!placeholder}
      required={isRequired}
      onKeyDown={typeof onKeyDown === "function" ? (e) => onKeyDown(e) : undefined}
      disabled={disabled}
      autoComplete="address-level2"
    />
  );
};
